import { formatGroupDropdownForBudgetTable, formatLineitem } from "../Budget";
import { budgetTypesOptions } from "../../constants";

const formatBudgetData = (data, financialsConfiguration, currentUser) => {
  return {
    originalBudgetLineItems:
      data?.lineItems?.map((li) =>
        formatLineitem(
          li,
          financialsConfiguration?.financials?.divisionsObject,
          financialsConfiguration?.financials?.csiCodeMappingObject,
          data?.groups
        )
      ) || [],
    budgetGroups: formatGroupDropdownForBudgetTable(data?.groups),
    budgetLastUpdated: data?.metadata?.lastUpdated,
    budgetType:
      budgetTypesOptions?.find((type) => type.value === data?.budgetType) ??
      data?.budgetType,
    budgetSummary: data?.summary,
    budgetPendingUpdates: data?.pendingUpdates,
    budget: data?.budget,
    isLockGmp: data?.isLockGmp,
    isLockFixedFirm: data?.isLockFixedFirm,
    // TODO: replace this with budget lock when implemented
    isBudgetLocked: data?.lineItems?.some(
      (li) =>
        li.lock.lockedBy?.reference &&
        li.lock.lockedBy?.reference !== currentUser?.reference
    ),
  };
};

export default formatBudgetData;
